export const FORGOT_PASSWORD_REQUEST_CARD_TITLE = 'Forgot your password?';
export const FORGOT_PASSWORD_REQUEST_CARD_SUBTITLE =
  "Enter the email you use for Headliner and we'll help you create a new password.";
